import Crud from '@/stores/crudBase';
import api from '@/apis/in/inAdjustmentAPI.js';
var crud = new Crud('approveVoucherINAdjustmentList', api);

const state = {
  ...crud.state,
  _config: {
    table: 'in_adjustment',
    field: {
      key: 'ref_id',
      code: 'ref_no',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
